module.exports = {
	AQUADB_COOKIE: 'aquadb-be-user-accept-cookie',
	AQUADB_COOKIE_ADVERTISEMENT: 'advertisingCookies',
	AQUADB_COOKIE_STATISTICS: 'statisticsCookies',
	AQUADB_EXPIRE_DAYS: '30'
}



// WEBPACK FOOTER //
// ./src/utils/cookie/constants/CookieConstants.js